import React, {useState} from 'react';
import './TabChanger.scss';
import TextInBox from "../TextInBox/TextInBox";
import TextInBoxService from "../TextInBox/TextInBoxService";

const TabChanger = ({initialData, setSendData, sendData}) => {

    const [currentTab, setCurrentTab] = useState("TAB_ONE");

    const tabChanger = () => {
        if (currentTab === "TAB_ONE") {
            setCurrentTab("TAB_TWO")
        } else {
            setCurrentTab("TAB_ONE")
        }
    }

    const singleProductClickHandler = (singleObjectRowClicked) => {

        if (singleObjectRowClicked.number === undefined) {
            singleObjectRowClicked.number = 1
        }

        const sendDataProducts = [...sendData.products]
        const newArrayToReplaceInProducts = [];

        const hasEqual = sendDataProducts.filter(v => v.title === singleObjectRowClicked.title);
        if (hasEqual.length > 0) {
            sendDataProducts.forEach((v) => {

                if (v.title === singleObjectRowClicked.title)
                    v.number = +v.number + 1;
                newArrayToReplaceInProducts.push(v)
            })
        } else {

            sendDataProducts.forEach(v => {
                newArrayToReplaceInProducts.push(v)
            })
            newArrayToReplaceInProducts.push(singleObjectRowClicked)
        }

        newArrayToReplaceInProducts.forEach((v, index) => {
            v.rowId = index + 1;
        })

        setSendData({...sendData, products: newArrayToReplaceInProducts})
    }

    const reGenerateRowId = (temp) => {
        temp.forEach((v, index) => {
            v.rowId = index + 1;
        })
        return temp;
    }
    const addNumberOfWorkers = object => ({...object, number: "1"})
    const servicesListWorkerModalHandler = (workerArrayList) => {
        workerArrayList = addNumberOfWorkers({...workerArrayList})
        let tempArray;
        const hasEqual = sendData.services.filter(v => v.title === workerArrayList.title);
        if (hasEqual.length > 0) {
            tempArray = sendData.services.map(v => {
                const temp = {...v}
                if (temp.title === workerArrayList.title) {
                    return workerArrayList
                }
                return temp;
            });

        } else {

            tempArray = [...sendData.services, workerArrayList];
        }

        tempArray = reGenerateRowId(tempArray)

        setSendData({...sendData, services: tempArray})

    };

    return (

        <div className="main-tab-changer">

            <div className="top-tab">

                <span onClick={tabChanger}>
                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle
                            cx="5.5" cy="13.5" r="5.5" fill="#33B0B1"/>
                        <circle cx="15.5" cy="2.5" r="2.5" fill="#009C9D"/>
                    </svg>
                    خدمات
                </span>

                <span onClick={tabChanger}>
                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle
                            cx="5.5" cy="13.5" r="5.5" fill="#33B0B1"/>
                        <circle cx="15.5" cy="2.5" r="2.5" fill="#009C9D"/>
                    </svg>
                    کالاها
                </span>

                <div className={`color-move ${currentTab === "TAB_ONE" ? "tab-one" : "tab-two"}`}></div>

            </div>

            <div className="content-tab">

                <div className={`service-side ${currentTab === "TAB_TWO" ? "service-side-hidden" : ""}`}>

                    <TextInBoxService ComponentData={initialData}
                                      servicesListWorkerModalHandler={servicesListWorkerModalHandler}/>
                </div>

                <div className={`product-side ${currentTab === "TAB_TWO" ? "product-side-show" : ""}`}>
                    {initialData.products?.map((v, index) => {
                            return <TextInBox key={"P" + index} ComponentData={v}
                                              onClick={() => singleProductClickHandler(v)}/>
                        }
                    )}
                </div>

            </div>

        </div>

    );
};

export default TabChanger;